"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// The reducer limits you to 24 unique entries currently.
var MAX_INDEX = 23;
exports.default = {
    SearchPeopleIndex: {
        datapoint: {
            name: 'SearchPeopleIndex',
            options: { isQos: true },
        },
    },
    FPThresholdHit: {
        datapoint: {
            name: 'FindPeopleThresholdHit',
        },
    },
    AddRecipientFromFindControl: {
        datapoint: {
            name: 'AddRecipientFromFindControl',
            customData: function (index, source) {
                return {
                    index: (index > MAX_INDEX ? MAX_INDEX : index).toString(),
                    source: source.toString(),
                };
            },
        },
    },
};
//# sourceMappingURL=datapoints.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/datapoints.js
// module id = 2690
// module chunks = 2 3 4 45